<template>
  <div class="success">
    <Check />
    <strong>Success!</strong>
    <p>Your product has been successfully updated!</p>
    <Button
      plain
      @click="$emit('close')"
    >
      Close
    </Button>
  </div>
</template>

<script>
// eslint-disable-next-line
import Check from '../../../public/check.svg?inline';
import Button from '../ui/Button.vue';

export default {
  name: 'Success',
  components: {
    Check,
    Button,
  },
};
</script>

<style lang="scss" scoped>
.success {
  padding: 30px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  svg {
    width: 100px;
    margin-bottom: 20px;
  }

  strong {
    font-weight: 700;
    font-size: 20px;
  }

  p {
    font-weight: 500;
    font-size: 14px;
    line-height: 150%;
  }
}
</style>
